import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Gavel, LogOut, Shield, Home, Users, ListChecks, Menu, X } from "lucide-react";
import { useState } from "react";
import NotificationBell from "@/components/NotificationBell";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(false);
  return (
    <div className="min-h-screen bg-cream">
      <nav className="border-b-2 border-black bg-white sticky top-0 z-30">
        <div className="mx-auto max-w-6xl px-3 sm:px-6 py-3 flex items-center justify-between gap-2 sm:gap-4">
          <button data-testid="nav-home-btn" onClick={() => navigate("/dashboard")} className="flex items-center gap-2 shrink-0">
            <div className="w-9 h-9 bg-sunny border-2 border-black rounded-lg shadow-brutsm flex items-center justify-center">
              <Gavel strokeWidth={3} className="w-5 h-5" />
            </div>
            <span className="font-fredoka text-xl font-bold">Ricky</span>
          </button>

          {/* Right cluster: always visible essentials + hidden nav on mobile */}
          <div className="flex items-center gap-2">
            <Link data-testid="nav-dashboard" to="/dashboard" className="brut-btn-white px-3 py-2 text-sm hidden lg:inline-flex">
              <Home strokeWidth={3} className="w-4 h-4"/> Dashboard
            </Link>
            <Link data-testid="nav-mybids" to="/my-bids" className="brut-btn-sky px-3 py-2 text-sm hidden lg:inline-flex">
              <ListChecks strokeWidth={3} className="w-4 h-4"/> My bids
            </Link>
            <Link data-testid="nav-members" to="/members" className="brut-btn-mint px-3 py-2 text-sm hidden lg:inline-flex">
              <Users strokeWidth={3} className="w-4 h-4"/> Members
            </Link>
            {user?.is_admin && (
              <Link data-testid="nav-admin" to="/admin" className="brut-btn-peach px-3 py-2 text-sm hidden lg:inline-flex">
                <Shield strokeWidth={3} className="w-4 h-4"/> Admin
              </Link>
            )}
            <NotificationBell/>
            <div className="chip whitespace-nowrap" data-testid="nav-points">
              <span className="font-fredoka">{user?.points ?? 0}</span> pts
            </div>
            <div className="hidden xl:flex items-center gap-2 border-2 border-black rounded-full pl-1 pr-3 py-1 bg-lilac shadow-brutsm">
              {user?.picture ? (
                <img src={user.picture} alt="" className="w-6 h-6 rounded-full border-2 border-black object-cover"/>
              ) : (
                <div className="w-6 h-6 rounded-full border-2 border-black bg-white"/>
              )}
              <span className="text-sm font-bold">{user?.name}</span>
            </div>
            <button data-testid="nav-logout-btn" onClick={logout} className="brut-btn-white px-3 py-2 text-sm hidden lg:inline-flex" title="Sign out">
              <LogOut strokeWidth={3} className="w-4 h-4"/>
            </button>
            <button data-testid="nav-menu-btn" onClick={() => setOpenMenu(v => !v)}
              className="brut-btn-white px-3 py-2 text-sm lg:hidden" title="Menu" aria-label="Menu">
              {openMenu ? <X strokeWidth={3} className="w-4 h-4"/> : <Menu strokeWidth={3} className="w-4 h-4"/>}
            </button>
          </div>
        </div>

        {openMenu && (
          <div data-testid="mobile-menu" className="lg:hidden border-t-2 border-black bg-cream px-4 py-3 grid grid-cols-2 gap-2">
            <Link data-testid="menu-nav-dashboard" to="/dashboard" onClick={() => setOpenMenu(false)} className="brut-btn-white justify-start">
              <Home strokeWidth={3} className="w-4 h-4"/> Dashboard
            </Link>
            <Link data-testid="menu-nav-mybids" to="/my-bids" onClick={() => setOpenMenu(false)} className="brut-btn-sky justify-start">
              <ListChecks strokeWidth={3} className="w-4 h-4"/> My bids
            </Link>
            <Link data-testid="menu-nav-members" to="/members" onClick={() => setOpenMenu(false)} className="brut-btn-mint justify-start">
              <Users strokeWidth={3} className="w-4 h-4"/> Members
            </Link>
            {user?.is_admin && (
              <Link data-testid="menu-nav-admin" to="/admin" onClick={() => setOpenMenu(false)} className="brut-btn-peach justify-start">
                <Shield strokeWidth={3} className="w-4 h-4"/> Admin
              </Link>
            )}
            <button data-testid="menu-nav-logout" onClick={() => { setOpenMenu(false); logout(); }} className="brut-btn-white justify-start col-span-2">
              <LogOut strokeWidth={3} className="w-4 h-4"/> Sign out
            </button>
          </div>
        )}
      </nav>
      <main className="mx-auto max-w-6xl px-4 sm:px-6 py-8">{children}</main>
    </div>
  );
}
